import { useCallback, useLayoutEffect, useSyncExternalStore } from 'react';
import { identiteCourante } from '../auth/identite.js';
import { DEFAULT_DESIGN, isHorizontalDesign, type DesignId } from './designs.js';
import {
  applyDesign,
  designEffectif,
  lirePolitiqueTheme,
  subscribeDesign,
  writeDesign,
} from './designStore.js';

/** Omitting the account reads the authenticated identity; null is explicitly anonymous. */
export function useDesign(compteId?: string | null) {
  // Do not subscribe a business page to gallery identity transitions: while the
  // router awaits the next loader, that would remount queries for the old gallery
  // immediately after their cache has been purged. Account changes are observed
  // by the isolated root bridge and the shell session.
  const identite = identiteCourante();
  const account = compteId === undefined ? (identite?.compteId ?? null) : compteId;
  // Lot C: the gallery's theme policy (set by the console) decides first.
  const snapshot = useCallback(() => designEffectif(account), [account]);
  const design = useSyncExternalStore(subscribeDesign, snapshot, () => DEFAULT_DESIGN);
  const setDesign = useCallback(
    (next: DesignId) => {
      // Locked by the console: no stored choice can override the theme.
      if (!lirePolitiqueTheme().libre) return;
      writeDesign(account, next);
    },
    [account],
  );
  // Apply before paint, including transitions to another account or sign-out.
  useLayoutEffect(() => {
    applyDesign(design);
  }, [design, account]);
  return { design, setDesign, horizontal: isHorizontalDesign(design) };
}

// Les liens `?design=` sont consommés par `useEntryParams` (preferences/).
